import React from 'react'
import Menu from '../../components/Menu/Navbar'
import Header from '../../components/Header/header'
import Logo from '../../components/Logo/logo'
import Footer from '../../components/Footer/footer'
import BannerNoticias from '../../components/BannerNoticias/bannernoticias'
import NoticiaPrincipal from '../../components/-NoticiasView/noticias'



const Team = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <BannerNoticias />
      <NoticiaPrincipal />

      <Footer />
      <></>
    </div>
  )
}

export default Team
